import { put, takeLatest } from "redux-saga/effects";
import { eDanhSachNganh2ActionIds } from "../../action-types/quan-ly-nganh-2/IDanhSachNganh2Actions";
import { rootActions } from "../../actions/rootActions";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { call } from "redux-saga/effects";
import { danhSachNganh2Api } from "../../../api/quan-ly-nganh-2/danhSachNganh2Api";

export function* danhSachNganh2Saga(): any {
    yield takeLatest(eDanhSachNganh2ActionIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
    const res: IBaseResponse = yield call(danhSachNganh2Api.SelectAll);
    if (res.is_success) {
        yield put(rootActions.quanLyNganh2.danhSachNganh2.LOAD_SUCCESS(res.data));
    } else {
        yield put(rootActions.quanLyNganh2.danhSachNganh2.LOAD_ERROR(res.message ?? "Có lỗi khi tải danh sách ngành 2"));
    }
}